

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BankParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Bank {
  

    bankId?: any;
    name: string;   
    branchNumber: string;
    ifsc:string;
    address:string;
    contactPerson:string;
    contactPhone:string;
    accountNumber:string;
    tenantId?: string;
    BranchId?: string;

    
  parameters?: BankParameter[];
  links?: any;
}

export abstract class BankData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Bank[]>;
  abstract create(url: string,data: Bank): Observable<any>;
  abstract update(url: string,data: Bank): Observable<any>;
  abstract delete(url: string): Observable<any>;
}

